import { get } from "lodash";
import { Component, Input, TemplateRef } from "@angular/core";

import {
  MedTableColumnConfig,
  MedTableDataRow,
  MedTableSettings,
} from "../types";
import { MedTableTemplates } from "../types.local";
import { NgClassType } from "../../../types";
import { TypeChecker } from "../../../services/TypeChecker";
import { TABLE_DATA_CELL_TEMPLATE } from "../constants/prefixes";

const typeChecker = new TypeChecker();

@Component({
  selector: "med-table-cell",
  templateUrl: "./med-table-cell.component.html",
  styleUrls: ["./med-table-cell.component.scss"],
})
export class MedTableCellComponent<DataType extends MedTableDataRow> {
  @Input() index!: number;
  @Input() data!: DataType;
  @Input() settings!: MedTableSettings;
  @Input() column!: MedTableColumnConfig;
  @Input() templates?: MedTableTemplates;

  get classList(): NgClassType {
    return this.column.dataCellClass || "";
  }

  get value() {
    if (typeChecker.isBoolean(this.data)) {
      return this.data;
    }

    const { defaultValue } = typeChecker.isUndefined(this.column.defaultValue) ? this.settings : this.column;

    return get(this.data, this.column.key) || defaultValue;
  }

  get template(): TemplateRef<any> | null {
    return this.templates?.[this.column.key] || this.templates?.[TABLE_DATA_CELL_TEMPLATE] || null;
  }
}
